// src/routes/administracion/AdministracionRoutes.js
import React, { lazy } from 'react';
import ProtectedRoute from '../ProtectedRoute';
import { ROLES } from '../../constants/roles';

// Componente cargado de forma diferida
const Administracion = lazy(() => import('../../components/dashboard/Administracion/Administracion'));

// Roles usando constantes
const ROLES_ADMINISTRACION = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.RECURSOS_HUMANOS];

const administracionRoutes = [
  {
    path: 'administracion', // Ruta relativa
    element: <ProtectedRoute allowedRoles={ROLES_ADMINISTRACION}><Administracion /></ProtectedRoute>,
  },
  // Podrías añadir aquí sub-rutas como 'administracion/usuarios', 'administracion/configuracion' si las separas de '/admin/users'
];

export default administracionRoutes;